import React from 'react';
import { Link } from 'react-router-dom';
import './style.css';

const joinOptions = [
    {
        icon: 'fas fa-hands-helping',
        label: 'Volunteer',
         link: '/volunteer',
    },
    {
        icon: 'fas fa-handshake',
        label: 'Partner with us',
        link: 'partner',
    },
    {
        icon: 'fas fa-credit-card',
        label: 'Donate',
        link: '/make-donation',
    },
];

const HeartbeatSection = () => {
  return (
    <section className="heartbeat_section section_padding join-prolove-section">
      <div className="container">
        <div className="row align-items-center join-prolove-row">
          <div className="col-lg-6 col-md-12 join-prolove-text-col">
            <div className="join-prolove-content">
              <h2 className="join-prolove-heading">Join the Mission...</h2>
              <p className="join-prolove-subheading">Together, we can be the hands and feet of Christ, making sure no mother feels alone in her
journey. Help Her feel Loved!</p>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 join-prolove-cta-col">
            <div className="join-prolove-cta-stack">
              {joinOptions.map((option, idx) => (
                <Link to={option.link} className="join-prolove-cta-card" key={idx}>
                  <span className="join-prolove-cta-icon"><i className={option.icon}></i></span>
                  <span className="join-prolove-cta-label">{option.label}</span>
                  <span className="join-prolove-cta-arrow">&rarr;</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeartbeatSection;
